import React from "react";
import { createFormItemRow } from "#components/SForm";
import { Modal } from "@bedrock/components";
import { enums } from "#services";
import StatementAttachment from "#features/StatementAttachment";
import InvoiceInformation from '@mpc/common/src/features/InvoiceInformation';


const basicOption = [
    {
        name: '是',
        value: true
    },
    {
        name: '否',
        value: false
    },
]

const INVOICEOption = enums.InvoiceBelongAreaEnum.values()

const ModalConfirm = ({ value, oldValue, title, content, formData }) => {
    return new Promise((resolve, reject) => {
        if (oldValue === undefined) {
            resolve(value)
            return
        }
        if (formData.invoice_list.length) {
            Modal.confirm({
                title,
                content,
                onOk: () => {
                    resolve(value)
                },
                onCancel: () => {
                    reject(oldValue)
                }
            })
        } else {
            resolve(value)
        }
    })
}

const getInvoiceRequired = ({detailData}) => {
    if (detailData?.$isHideInvoice) {
        return false
    }
    if (detailData?.state === 'making') {
        return !detailData?.demand_suppliers?.[0]?.inner_supplier
    }
    return true    
}

const SettlementStatementFormModal = createFormItemRow({
    invoice_belong_area: {
        label: '发票国家/地区',
        required: getInvoiceRequired,
        componentClass: 'select',
        col: 12,
        elementProps: ({ detailData, formData }) => {
            return {
                options: INVOICEOption,
                disabled: detailData?.$isHideInvoice,
                changeInterceptor: (value, oldValue) => {
                    return ModalConfirm({
                        value, oldValue, formData,
                        title: '确定更改发票国家/地区吗？',
                        content: '更改后，发票信息会清空，需重新上传',
                    })
                }
            }
        }
    },
    is_oversea_invoice: {
        label: '是否海外INVOICE',
        required: getInvoiceRequired,
        componentClass: 'radio',
        col: 12,
        elementProps: ({ formData, detailData }) => {
            return {
                options: basicOption,
                disabled: formData?.invoice_belong_area !== 1 || detailData?.$isHideInvoice,
                changeInterceptor: (value, oldValue) => {
                    return ModalConfirm({
                        value, oldValue, formData,
                        title: '确定更改是否海外INVOICE吗？',
                        content: '更改后，发票信息会清空，需重新上传',
                    })
                }
            }
        }
    },
    invoice_list: {
        label: '发票信息',
        required: getInvoiceRequired,
        col: 24,
        validateTrigger: false,
        watchChildFormValidate: true,
        render: ({ formData, detailData }, { view, elementProps }) => {
            const content = {
                isHideInvoice: detailData?.$isHideInvoice,
                belongArea: formData.invoice_belong_area,
                isOverseaInvoice: formData.is_oversea_invoice,
                currency: detailData?.demand_suppliers?.[0]?.demand_supplier_quotes?.[0]?.currency // 非绑定执行数据的货币类型
                    || detailData?.demand_advertising?.dspf_offer_currency // 绑定执行数据外包
                    || detailData?.dspf_quota_data?.dspf_offer_currency // 绑定执行数据，内包
                    || "RMB",
                demandId: detailData?.id,
            }
            return <InvoiceInformation view={view} content={content} showInvoiceSource={elementProps?.showInvoiceSource} />
        }
    },
    signed_statement_attachs: {
        label: '结算单附件',
        required: true,
        col: 24,
        validateTrigger: false,
        watchChildFormValidate: true,
        render: ({ detailData }, { view }) => {
            return <StatementAttachment view={view} detail={detailData || {}} />
        }
    }
});

export default SettlementStatementFormModal;